import React, { useRef, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  OTP_LENGTH,
  useCognito,
  useCognitoDispatch,
} from 'components/Cognito/CognitoContextProvider'
import OTPInput from 'components/Shared/OTPInput'
import { SecondaryButton } from 'components/Shared/Button'
import RememberDevice from './RememberDevice'
import { mfaTypes } from 'components/Cognito/types'
import MFASwitcher from './MFASwitcher'
import { FormPage } from 'components/Cognito/Shared/FormPage'
import { usePostLoginRedirect } from 'components/Cognito/hooks'
import InactiveUserModal from 'components/Cognito/Shared/InactiveUserModal'

export default function MFAChallenge() {
  const { t } = useTranslation()
  const { handleMFAChallenge } = useCognitoDispatch()
  usePostLoginRedirect()
  const {
    error,
    loading,
    challenge: { name: challengeName, username },
  } = useCognito()
  const [otp, setOtp] = useState('')
  const [rememberDevice, setRememberDevice] = useState(false)
  const otpRef = useRef(null)

  if (![mfaTypes.softwareTokenMfa, mfaTypes.emailTotp].includes(challengeName)) {
    return null
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    handleMFAChallenge({ mfaToken: otp, rememberDevice })
  }

  return (
    <FormPage
      className="mfa-challenge"
      title={t('Login.mfa.title')}
      subtitle={
        <Trans
          i18nKey={`Login.mfa.subtitle.${challengeName.toLowerCase()}`}
          components={{ div: <div />, p: <p /> }}
          values={{ email: username }}
        >
          {challengeName === mfaTypes.softwareTokenMfa && (
            <>Enter the code shown in your authenticator app<div>Code will be valid for 10 minutes</div></>
          )}
          {challengeName === mfaTypes.emailTotp && (
            <>
              Code successfully sent to the email: {{ email: username }}{' '}
              <div>Enter the code shown in your email</div>
            </>
          )}
        </Trans>
      }
    >
      <OTPInput ref={otpRef} onChange={setOtp} length={OTP_LENGTH} autoFocus />
      {error && <p className="mfa-challenge__error warning-red">{t(error)}</p>}
      <RememberDevice rememberDevice={rememberDevice} onChange={setRememberDevice} />
      <MFASwitcher
        onResend={() => {
          if (otpRef.current) {
            otpRef.current.clear()
          }
          setOtp('')
        }}
        onSwitch={() => {
          if (otpRef.current) {
            otpRef.current.clear()
          }
          setOtp('')
        }}
      />
      <SecondaryButton
        color="navy"
        text={loading ? t('common.loading') : t('Login.mfa.completeLogin')}
        onClick={handleSubmit}
        disabled={loading || otp.length !== OTP_LENGTH}
        classNames="mfa-challenge__submit"
        fullWidth={false}
      />
      <InactiveUserModal />
    </FormPage>
  )
}
